import { app } from "@microsoft/teams-js";
import { ScheduleDTO, SurveyDTO } from "@teams/types/api";

import { isError } from "../services/ChannelApi";
import { scheduleApi } from "../services/ScheduleApi";
import { surveyApi } from "../services/SurveyApi";

export const downloadSurveyCsv = async (
  survey: SurveyDTO,
  teamsContext: app.Context
): Promise<string | Error> => {
  const exportData = await surveyApi.exportSurveyCsv(teamsContext, survey.id!);

  if (isError(exportData)) {
    return exportData;
  }
  return downloadResultsCsv(exportData, survey.title.substring(0, 20));
};

export const downloadSeriesCsv = async (
  schedule: ScheduleDTO,
  teamsContext: app.Context
): Promise<string | Error> => {
  const exportData = await scheduleApi.exportSeriesCsv(teamsContext, schedule.id);
  if (isError(exportData)) {
    return exportData;
  }
  return downloadResultsCsv(exportData, schedule.name.substring(0, 20));
};

const downloadResultsCsv = (data: string, fileName: string) => {
  const universalBOM = "\uFEFF";

  const url = window.URL.createObjectURL(
    new Blob([universalBOM + data], {
      type: "text/csv",
    })
  );
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", `${fileName}.csv`);
  link.setAttribute("target", "_blank");
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);

  return fileName;
};
